export default {
    "title": "Delivery Notes / {{client}}",
    "description": "Delivery notes list with PDF download",
    "filters": {
        "deliveryNotesNumber": "Delivery Notes number"
    },
    "deliveryNotesHeader": "<0>{{count}}</0> delivery notes",
    "deliveryNotesTableColumns": {
        "date": "Delivery Notes date",
        "client_id": "Client ID",
        "order_id": "Order number",
        "delivery_id": "Delivery Note number",
        "invoice_id": "Invoice number",
        "invoice_date": "Invoice date",
        "pdf_order_download": "Delivery Note download (PDF)",
        "pdf_packing_list_download": "Packing List download (XLS)"
    },
    "nameCollection": "delivery notes"
};